import api from "@/api";
import { AuthViaDigitalSignData, AuthViaDigitalSignResultData, VerifyOtpForDigitalSign, VerifyOtpForDigitalSignResult } from "../types/auth-via-digital-sign";

export const $authViaDigitalSign = async (
	body: AuthViaDigitalSignData
): Promise<AuthViaDigitalSignResultData | null> => {
	// mock
	// const response: AuthViaDigitalSignResultData = {
	// 	needOtp: false,
	// 	accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJpbmZpbmJhbmsudXoiLCJleHAiOjE2NzI4MTQwNDUsImdyb3VwcyI6WyJESVJFQ1RPUiJdLCJ1cG4iOiIxNDE3NTk0Iiwic2Vzc2lvbklkIjo1MjYzNiwidWxDcm1JZCI6MTAxNDU4MSwibWZvIjoiMDEwNDEiLCJuY2lJZCI6IjA0NDAwNzY0IiwiaWF0IjoxNjcyODEzNDQ1LCJqdGkiOiI4N2RhY2U3Mi1mZmM0LTQxYjYtODFkNC00OTg1NjU3ZDVlZmUifQ.Y6JGw2ZW_aKPZUsCZWTlaSRGI8pYIgpdbC2K6ika6u4iVq-Cr3p7NKvcCqpAF9KzwgukiEwq187sZM2LjU7y8aQGz2GPwhVdSNSe9LXn0xkRHu6rIfW6gAdTPxRgnxxfxa4L-vul4Y-ZukCSMaX1Xmi6edTCxgYnbGnFpQaHY6Qxxu2Y13gwaqRAtTpx861vrrzOKDbm6liTTQ4t6C7XahK13bdQ9I_jr5CVFUSBpJR7hBS5Zje9Ynim0h81HILHfbLvvkoavbR4G-gd6yzt7R-tHzqAGKwwBcl3WG5mFvjzqhY9Tr4NeWc0vqF0YFhenXC8tb98GA_RhbixA6dpPg',
	// 	refreshToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJpbmZpbmJhbmsudXoiLCJleHAiOjE2NzM0MTgyNDUsInVwbiI6IjE0MTc1OTQiLCJzZXNzaW9uSWQiOjUyNjM2LCJpYXQiOjE2NzI4MTM0NDUsImp0aSI6ImYwYzJjMjRlLWFlOGMtNDA4Zi05NDNjLTBhMjg5ZDdjMWE0MiJ9.R9khIsR2y1oxYx6aWfrcT_6Js24-NDT45G0tyS5jB7Db4iEDlWU-M6XqjYXQdbuPyZmpvPfhlPj-Vf65KnfsStFWEcJIp94Gez2OgBrN0fPJolR_XaJmJrIejQiU8my2he09uNEu74Ri3gSGu_LMVNv0e_lTorZQGcR_75hkBcyDrd35PBI3BerexrcYafXfHGspU5bEjJ_9uwmE5gKiQa1QhX428NVyZFJnKHXe4X-xYnE2aRVU5Zx96CSo48XTGTfD7KvtC8wWVauN4sqEudpSbChgXma0LceDJcsJND7b1CE44LYqHQrlYJKc5nM64upaKFqKe2XfngaHiHzyzA'
	// };

	// console.log('POST /auth/login-with-digital-sign', body, response);

	// return response;

	return api
		.post('auth/login-with-digital-sign', body, {
			handler: { skipSessionExpired: true }
		});
};

export const $verifyOtpForAuthViaDigitalSign = async (
	body: VerifyOtpForDigitalSign
): Promise<VerifyOtpForDigitalSignResult | null> => {
	return api
		.post('auth/digital-login', body, {
			handler: { skipSessionExpired: true }
		});
};